import axios from "axios";
import { apiUrl } from '../../constant';
import { FETCH_BUSINESS_LIST_SUCCESS, FETCH_CARRIER_LIST_SUCCESS, FETCH_MARKETPLACE_LIST_SUCCESS, FETCH_PRODUCT_TYPE_LIST_SUCCESS, FETCH_USER_ONBOARDING_FAILED, FETCH_USER_ONBOARDING_PENDING, FETCH_USER_ONBOARDING_SUCCESS } from "../types";

const buildOnboardingQuery = (params = {}) => {
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });

    const query = queryParams.toString();
    return query ? `?${query}` : '';
};

const appendIsApproved = (baseUrl, isApproved = false, extraParams = {}, userEmailId = '') => {
    const merged = { ...extraParams, IsApproved: Boolean(isApproved) };
    if (userEmailId) {
        merged.userEmailId = userEmailId;
    }
    const query = buildOnboardingQuery(merged);
    return `${baseUrl}${query}`;
};


const getAccountDetailsPending = () => ({
    type: FETCH_USER_ONBOARDING_PENDING,
});
const getAccountDetailsFailed = () => ({
    type: FETCH_USER_ONBOARDING_FAILED,
});
const getAccountDetailsSuccess = (response) => ({
    type: FETCH_USER_ONBOARDING_SUCCESS,
    payload: response,
});


export const getAccountDetails = (isViewUserRequest, data, isApproved = false) => {
    return (dispatch) => {
        dispatch(getAccountDetailsPending());

        const onboardingId = data?.Id || data?.onboardingId || 0;
        const extraParams = {};
        if (isViewUserRequest && onboardingId) {
            extraParams.onboardingId = onboardingId;
        }
        const url = appendIsApproved(
            `${apiUrl}/api/Onboarding/account-details`,
            isApproved,
            extraParams,
            data?.userEmailId || ''
        );

        axios.get(url)
            .then((result) => {
                dispatch(getAccountDetailsSuccess(result.data.Entity));
            })
            .catch(() => {
                dispatch(getAccountDetailsFailed());
            });
    };
};

const getBusinessesListSuccess = (response) => ({
    type: FETCH_BUSINESS_LIST_SUCCESS,
    payload: response,
});

export const getBusinessesList = (isApproved = false, userEmailId = '') => {
    return (dispatch) => {
        axios.get(appendIsApproved(`${apiUrl}/api/Onboarding/business-models`, isApproved, {}, userEmailId)).then((result) => {
            dispatch(getBusinessesListSuccess(result.data.EntityList));
        }).catch((error) => {
            console.log(error);
        });
    };
};

const getProductTypeListSuccess = (response) => ({
    type: FETCH_PRODUCT_TYPE_LIST_SUCCESS,
    payload: response,
});


export const getProductTypeList = (isApproved = false, userEmailId = '') => {
    return (dispatch) => {
        axios.get(appendIsApproved(`${apiUrl}/api/Onboarding/product-types`, isApproved, {}, userEmailId)).then((result) => {
            dispatch(getProductTypeListSuccess(result.data.EntityList));
        }).catch((error) => {
            console.log(error);
        });
    };
};

const getMarketPlaceListSuccess = (response) => ({
    type: FETCH_MARKETPLACE_LIST_SUCCESS,
    payload: response,
});

export const getMarketPlaceList = (isApproved = false, userEmailId = '') => {
    return (dispatch) => {
        axios.get(appendIsApproved(`${apiUrl}/api/Onboarding/marketplaces`, isApproved, {}, userEmailId)).then((result) => {
            dispatch(getMarketPlaceListSuccess(result.data.EntityList));
        }).catch((error) => {
            console.log(error);
        });
    };
};

const getCarrierListSuccess = (response) => ({
    type: FETCH_CARRIER_LIST_SUCCESS,
    payload: response,
});

export const getCarrierList = (isApproved = false, userEmailId = '') => {
    return (dispatch) => {
        axios.get(appendIsApproved(`${apiUrl}/api/Onboarding/carriers`, isApproved, {}, userEmailId)).then((result) => {
            dispatch(getCarrierListSuccess(result.data.EntityList));
        }).catch((error) => {
            console.log(error);
        });
    };
};

export const saveAdditionalDetails = (data, isApproved = false, userEmailId = '') => {
    return axios.post(appendIsApproved(`${apiUrl}/api/Onboarding/save-business-info`, isApproved, {}, userEmailId), data);
}

export const getAdditionalDetails = (userId, isApproved = false, userEmailId = '') => {
    const url = appendIsApproved(
        `${apiUrl}/api/Onboarding/get-business-info`,
        isApproved,
        userId ? { onboardingId: userId } : {},
        userEmailId
    );

    return axios.get(url);
};

export const getPaymentPreferencesList = (isApproved = false, userEmailId = '') => {
    return axios.get(appendIsApproved(`${apiUrl}/api/Onboarding/payment-preferences`, isApproved, {}, userEmailId));
};

export const getPaymentPreferences = (userId, isApproved = false, userEmailId = '') => {
    const url = appendIsApproved(
        `${apiUrl}/api/Onboarding/get-payment-setup`,
        isApproved,
        userId ? { onboardingId: userId } : {},
        userEmailId
    );

    return axios.get(url);
};

export const savePaymentPreferences = (data, isApproved = false, userEmailId = '') => {
    return axios.post(appendIsApproved(`${apiUrl}/api/Onboarding/save-payment-setup`, isApproved, {}, userEmailId), data);
}

export const verifySignupToken = (data) => {
    return axios.post(`${apiUrl}/api/login/verify_signup_token`, data);
}

export const getKycDetails = (data, isApproved = false, userEmailId = '') => {
    return axios.post(appendIsApproved(`${apiUrl}/api/Onboarding/get-kyc-details`, isApproved, {}, userEmailId), data);
}

export const uploadKycDetails = (data, isApproved = false, userEmailId = '') => {
    return axios.post(appendIsApproved(`${apiUrl}/api/Onboarding/upload-kyc-documents`, isApproved, {}, userEmailId), data);
}

export const deleteOnboardingDocument = (data, isApproved = false, userEmailId = '') => {
    return axios.post(appendIsApproved(`${apiUrl}/api/Onboarding/delete-onboarding-document`, isApproved, {}, userEmailId), data);
}

export const getAgreementDetails = (data, isApproved = false, userEmailId = '') => {
    return axios.post(appendIsApproved(`${apiUrl}/api/Onboarding/get-agreement-details`, isApproved, {}, userEmailId), data);
}
export const uploadAgreementDocuments = (data, isApproved = false, userEmailId = '') => {
    return axios.post(appendIsApproved(`${apiUrl}/api/Onboarding/upload-agreement-documents`, isApproved, {}, userEmailId), data);
}

export const getDocumentStatusOptions = (isApproved = false, userEmailId = '') => {
    return axios.get(appendIsApproved(`${apiUrl}/api/Onboarding/document-status-options`, isApproved, {}, userEmailId));
}

export const updateAgreementStatus = (data, isApproved = false, userEmailId = '') => {
    return axios.post(appendIsApproved(`${apiUrl}/api/Onboarding/update-document-status`, isApproved, {}, userEmailId), data);
}

export const downloadAgreement = (data, isApproved = false, userEmailId = '') => {
    return axios.post(appendIsApproved(`${apiUrl}/api/Onboarding/generate-document-pdf`, isApproved, {}, userEmailId), data);
}

export const creditCardTypes = () => {
    return axios.get(appendIsApproved(`${apiUrl}/api/Onboarding/credit-card-types`));
}